export default "__VITE_ASSET__DUTriPmg__"